import React, { FC } from 'react';
import { CountryComponent, CountryFlag } from './Country.styles';
import { CountryProps } from './types';
import { useCountries } from 'context/DataContext';
import 'flag-icons/css/flag-icons.min.css';

const Country: FC<CountryProps> = ({ countryCode, fullWidth = false }) => {
  const countriesData = useCountries();

  const country = countriesData.find((c) => c.code === countryCode);

  return (
    <CountryComponent fullWidth={fullWidth}>
      <CountryFlag className={`fi fi-${countryCode.toLowerCase()}`} />
      <span>{country?.name}</span>
    </CountryComponent>
  );
};

export default Country;
